import { TParams } from '@global-types/app/app';
import { apiClient } from '@lib/api-client';
import { useQuery } from '@tanstack/react-query';

export type TGetUsersParams = TParams;

export const getUsers = (
	params: TGetUsersParams
): Promise<{
	rows: any[];
	total: number;
	page: number;
	pageSize: number;
	totalPages: number;
}> => {
	const { ...queryParams } = params;

	return apiClient.get('/users', {
		params: {
			query: queryParams,
			pageSize: 1000,
			page: 1,
		},
	});
};

export const useUsers = (
	enabled: { enabled: boolean },
	queryParams?: TGetUsersParams
) => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: [
			'users',
			{
				organization: queryParams?.organization,
				queryParams: queryParams,
			},
		],
		queryFn: () => getUsers(queryParams || {}),
		staleTime: 0,
		enabled: enabled.enabled,
	});

	const updateList = (users: any) =>
		users && Array.isArray(users)
			? users.reduce((acc: any, currentItem: any) => {
					const modifiedItem = {
						...currentItem,
					};
					acc.push(modifiedItem);

					return acc;
				}, [])
			: [];

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
